export const industryPriorities = [
  {
    "key": "manufacturing",
    "name": "Indústria de transformação",
    "nameEn": "Manufacturing",
    "summary": "Conecte conhecimento interno, procedimentos, documentos e qualidade para apoiar a operação e automatizar fluxos entre áreas.",
    "summaryEn": "Connect internal knowledge, procedures, documents and quality to support operations and automate cross-team workflows.",
    "meta": "Conhecimento · Qualidade · Operações",
    "metaEn": "Knowledge · Quality · Operations"
  },
  {
    "key": "transport",
    "name": "Logística, transporte e distribuição",
    "nameEn": "Logistics, transport and distribution",
    "summary": "Processe comprovantes e documentos, acompanhe entregas e exceções, atualize sistemas e conecte clientes, equipes e parceiros.",
    "summaryEn": "Process proof of delivery and documents, track deliveries and exceptions, update systems and connect customers, teams and partners.",
    "meta": "Entregas · Documentos · Exceções",
    "metaEn": "Deliveries · Documents · Exceptions"
  },
  {
    "key": "civil-engineering",
    "name": "Engenharia e construção civil",
    "nameEn": "Engineering and construction",
    "summary": "Organize informações de projetos, consulte contratos e especificações e apoie a leitura e validação de documentos e rotinas administrativas.",
    "summaryEn": "Organize project information, consult contracts and specifications and support document review and administrative workflows.",
    "meta": "Projetos · Contratos · Documentos",
    "metaEn": "Projects · Contracts · Documents"
  },
  {
    "key": "retail-wholesale",
    "name": "Varejo e atacado",
    "nameEn": "Retail and wholesale",
    "summary": "Amplie o atendimento e o apoio a vendas com informações de produtos, análise de conversas e automação dos processos de retaguarda.",
    "summaryEn": "Scale service and sales support with product information, conversation analysis and back-office process automation.",
    "meta": "Atendimento · Vendas · Retaguarda",
    "metaEn": "Service · Sales · Back office"
  },
  {
    "key": "financial-services",
    "name": "Serviços financeiros e seguros",
    "nameEn": "Financial services and insurance",
    "summary": "Apoie a análise documental, o atendimento e as equipes com processos conectados, acessos definidos e revisão humana. Planeje integrações, segurança e conformidade desde o início.",
    "summaryEn": "Support document analysis, service and teams with connected processes, defined access and human review. Plan integrations, security and compliance from the start.",
    "meta": "Documentos · Segurança · Conformidade",
    "metaEn": "Documents · Security · Compliance"
  },
  {
    "key": "healthcare",
    "name": "Saúde",
    "nameEn": "Healthcare",
    "summary": "Conecte atendimento administrativo, organização documental e processos internos, com controles de acesso e revisão adequados à sensibilidade dos dados.",
    "summaryEn": "Connect administrative service, document organization and internal processes with access controls and review suited to data sensitivity.",
    "meta": "Administração · Documentos · Privacidade",
    "metaEn": "Administration · Documents · Privacy"
  },
  {
    "key": "energy-utilities",
    "name": "Energia e serviços públicos",
    "nameEn": "Energy and utilities",
    "summary": "Apoie o atendimento e as equipes com consulta a procedimentos e automação de fluxos. Integração e governança acompanham a criticidade de cada operação.",
    "summaryEn": "Support customer service and teams with procedure queries and workflow automation. Match integration and governance to each operation’s criticality.",
    "meta": "Procedimentos · Integrações · Governança",
    "metaEn": "Procedures · Integrations · Governance"
  }
];
export const priorityTranslations = Object.fromEntries(industryPriorities.flatMap(item => [[item.name,item.nameEn],[item.summary,item.summaryEn],[item.meta,item.metaEn]]));
